import classNames from "classnames";
import React, { useState } from "react";

import { RecommendedProductI } from "../../App.types";
import { prepareProductItem } from "../../tracking/googleAnalytics";
import { triggerCustomEvent } from "../../utils/helpers/chromeEvents";
import { useSelector } from "../../utils/hooks";
import strings from "../../utils/strings";
import Button from "../common/button/Button";

import "./Product.scss";

interface ProductPropsI {
	product: RecommendedProductI;
	index: number;
}

export const Product = (props: ProductPropsI) => {
	const [isBought, toggleIsBought] = useState(false);
	const { product, index } = props;
	const currencyCode = useSelector((state) => state.popup.currencyCode);

	const addToCart = () => {
		triggerCustomEvent("addToCart", {
			regionalProductSku: product.regionalProductSku,
			clickTrackingUrl: product.clickTrackingUrl,
			url: product.url,
			name: product.productName,
			price: product.priceValue,
			sellerId: product.sellerId,
			sellerName: product.sellerName,
			brand: product.manufacturer,
			navigationPath: product.navigationPath,
			currencyCode,
			groupId: product.groupId,
			subGroupId: product.subGroupId,
			divisionId: product.divisionId,
			groupName: product.groupName,
			subGroupName: product.subGroupName,
			divisionName: product.divisionName,
			renewalPeriod: product.renewalPeriod,
			listActionField: "AddToCartPopup",
			trackingData: prepareProductItem({
				...product,
				index,
				productId: product.regionalProductSku,
				item_list_name: "AddToCartPopup",
				item_list_id: "recommendation_list",
			}),
		});

		toggleIsBought(true);
	};

	const buyMessage = product.displayAsSubscriptionProduct
		? product.buyMessage
		: strings.buy;

	const boughtMessage = product.displayAsSubscriptionProduct
		? product.buyMessage
		: strings.bought;

	return (
		<li
			key={product.regionalProductSku}
			className={classNames({
				"addtocart-list-product": true,
			})}
			aria-label={product.productName}
			title={product.productName}
			data-testid={`carousel-product-${product.regionalProductSku}`}
		>
			<div className="addtocart-recommendedProduct__image-wrapper">
				<img
					src={product.imgUrl}
					alt={product.productName}
					width="190"
					height="140"
					loading="lazy"
					decoding="async"
					className="addtocart-recommendedProduct__image"
				/>
			</div>
			<div className="addtocart-recommendedProduct__info">
				<h3>
					<a
						href={`${product.url}?productList=AddToCartPopup&position=${
							index + 1
						}`}
						target="_blank"
						className="addtocart-recommendedProduct__heading"
						id="recommendedProductName"
						rel="noreferrer"
					>
						{product.productName}
					</a>
				</h3>
				<p className="addtocart-paragraph">{product.productDescription}</p>

				<div className="addtocart-recommendedProduct__price">
					<Button
						message={buyMessage}
						bought={boughtMessage}
						onClick={addToCart}
					/>
					<div>
						<p className="addtocart-paragraph__price">
							{product.previousPrice !== product.price &&
								`${strings.before} ${product.previousPrice}`}
						</p>
						<p className="addtocart-price">{product.price}</p>
					</div>
				</div>
			</div>
		</li>
	);
};
